import { render, staticRenderFns } from "./productFinance.vue?vue&type=template&id=c8020560&scoped=true"
import script from "./productFinance.vue?vue&type=script&lang=js"
export * from "./productFinance.vue?vue&type=script&lang=js"
import style0 from "./productFinance.vue?vue&type=style&index=0&id=c8020560&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8020560",
  null
  
)

export default component.exports